module.exports = __webpack_public_path__ + "img/Paillage.07cb4380.webp";